export const config = {
    apiUrl: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
        ? 'https://nicarsys.com'
        : `http://${window.location.hostname}:8000`),
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
};